import clsx from "clsx";
import React, { FC } from "react";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { HeaderNotificationsMenu, HeaderUserMenu } from "../../../partials";
import { useLayout } from "../../core";
import { useNotifications } from "../../../../app/common/hooks/useNotifications";

const toolbarButtonMarginClass = "ms-1 ms-lg-3",
  //toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = "symbol-30px symbol-md-40px";
//toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const { config } = useLayout();
  const { unreadCount } = useNotifications();

  return (
    <div className="d-flex align-items-stretch flex-shrink-0">
      {/* begin::Notifications */}
      <div className="d-flex align-items-center me-3">
        <div
          className="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative"
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
          id="kt_menu_item_wow"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen007.svg"
            className="svg-icon-1"
          />
          {unreadCount > 0 && (
            <span
              className="position-absolute badge badge-circle badge-danger fs-8 fw-bolder"
              style={{
                top: "-4px",
                right: "-4px",
                minWidth: "18px",
                height: "18px",
                fontSize: "10px",
                lineHeight: "18px",
              }}
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </div>
        <HeaderNotificationsMenu />
      </div>
      {/* end::Notifications */}

      {/* begin::User */}
      <div
        className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}
        id="kt_header_user_menu_toggle"
      >
        {/* begin::Toggle */}
        <div
          className={clsx(
            "cursor-pointer symbol",
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <img src={toAbsoluteUrl("/media/avatars/300-1.jpg")} alt="metronic" />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {config.header.left === "menu" && (
        <>
          {/* <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>*/}
        </>
      )}
    </div>
  );
};

export { Topbar };
